import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnInit,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ById } from "../../../../model/filters/by-id";
import { MatchAny } from "../../../../model/filters/match.any";
import { Filter } from "../../../../model/filters/filter";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../../../services/navigation.helper";
import { NotComponent } from "../not/not.component";

@Component({
  selector: "by-id-form",
  templateUrl: "./by-id-form.component.html",
  styleUrls: ["./by-id-form.component.css"],
})
export class ByIdFormComponent implements OnInit {
  @Input() filter: ById | MatchAny = new ById(0);
  @Output() applyFilter = new EventEmitter<Filter>();

  @ViewChild(NotComponent) notComponent!: NotComponent;

  byIdForm: FormGroup;

  editingIndex: number | null = null;
  byIdFilter: ById = new ById(0);
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private nav: NavigationHelper
  ) {}

  ngOnInit(): void {
    const existingFilters =
      this.filter instanceof MatchAny ? this.filter.filters : [this.filter];

    const idListFromFilter: number[] = existingFilters
      .filter((f): f is ById => f instanceof ById)
      .map((f: ById) => f.id)
      .filter((id) => id !== undefined) as number[];

    const storedIds = localStorage.getItem("idList");
    const idListFromStorage = storedIds
      ? (JSON.parse(storedIds) as number[])
      : [];

    const mergedIds = Array.from(
      new Set([...idListFromFilter, ...idListFromStorage])
    );

    this.initializeForm(mergedIds);

    if (mergedIds.length > 0) {
      this.initializeForm(mergedIds);
    } else {
      // Senão, inicializa com apenas 1 campo vazio
      this.byIdForm = this.fb.group({
        registeredUsers: this.fb.array([
          this.fb.control(null, Validators.required),
        ]),
      });
    }
  }

  initializeForm(ids: number[]): void {
    const controls = ids.map((id) =>
      this.fb.control(id, [Validators.required, Validators.min(1)])
    );
    if (controls.length === 0) {
      controls.push(
        this.fb.control(null, [Validators.required, Validators.min(1)])
      );
    }

    this.byIdForm = this.fb.group({
      ids: this.fb.array(controls),
    });
  }

  restoreIds(ids: (number | null)[]): void {
    this.byIdForm.setControl("ids", this.fb.array([]));
    for (const id of ids) {
      this.ids.push(
        this.fb.control(id, [Validators.required, Validators.min(1)])
      );
    }
  }

  apply(): void {
    const ids: number[] = this.ids.value.filter(
      (id: number | null | undefined): id is number =>
        id !== null && id !== undefined
    );

    if (ids.length === 0) return;

    localStorage.setItem("idList", JSON.stringify(ids));

    let finalFilter: Filter;
    if (ids.length === 1) {
      finalFilter = new ById(ids[0]);
    } else {
      finalFilter = new MatchAny(ids.map((id) => new ById(id)));
    }

    this.notComponent.filter = finalFilter;
    const modifiedFilter: Filter = this.notComponent.getModifiedFilter();

    this.applyFilter.emit(modifiedFilter);
   
  }

  onFilterChanged(finalFilter: Filter): void {
    this.applyFilter.emit(finalFilter);

  }

  addIdField(): void {
    this.ids.push(
      this.fb.control(null, [Validators.required, Validators.min(1)])
    );

    const currentValues = this.ids.value.filter((id) => id !== null);
    localStorage.setItem("idList", JSON.stringify(currentValues));
  }

  setEditingIndex(index: number): void {
    this.editingIndex = index;
    localStorage.setItem("editingIdIndex", index.toString());
  }

  get ids(): FormArray<FormControl> {
    return this.byIdForm.get("ids") as FormArray<FormControl>;
  }
}
